import {
    GET_SALES_ORDER_HISTORY_REPORT_PROGRESS, GET_SALES_ORDER_HISTORY_REPORT_SUCCESS, GET_SALES_ORDER_HISTORY_REPORT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    salesOrderHistory: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const sales_order_history_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SALES_ORDER_HISTORY_REPORT_SUCCESS:
            return { ...state, salesOrderHistory: action.salesOrderHistory, loading: false };
        case GET_SALES_ORDER_HISTORY_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SALES_ORDER_HISTORY_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default sales_order_history_report_reducer;